import {BaseCard} from "../../Components/Cards/BaseCard";
import {faUser} from "@fortawesome/free-solid-svg-icons";
import {IconInputCard} from "../../Components/Cards/IconInputCard";
import {useBoundStore} from "../../Store/store";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import * as React from "react";
import {TextInput} from "../../Components/Form/TextInput";
import {SelectInput} from "../../Components/Form/SelectInput";
import {useForm} from "react-hook-form";
import DocumentsAdd from "../../Assets/images/illustrations/documents_add.svg";
import {useTranslation} from "react-i18next";

export const Freelancers = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const freelancers = useBoundStore((state) => state.freelancers)
    const getAllFreelancers = useBoundStore((state) => state.getAllFreelancers)
    const freelancersMetaData = useBoundStore((state) => state.freelancersMetaData)

    const [search, setSearch] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [statutenFilter, setStatutenFilter] = useState([]);

    const {control, setValue, getValues} = useForm({
        defaultValues: {statuten_filter: []},
    });

    const statutenOptions = [
        {id: 1, value: 'freelance', label: t('statuten.freelance')},
        {id: 2, value: 'interim', label: t('statuten.interim')},
        {id: 3, value: 'student', label: t('statuten.student')},
        {id: 4, value: 'flexi_job', label: t('statuten.flexi_job')},
    ];

    useEffect(() => {
        setCurrentPage(1);
    }, [search]);

    useEffect(() => {
        setIsLoading(true);
        getAllFreelancers(search, currentPage, null, statutenFilter).then(() => {
            setIsLoading(false);
        })
    }, [getAllFreelancers, search, currentPage, statutenFilter?.join(',')]);


    const goToNextPage = () => {
        if(canGoToNextPage()) {
            setCurrentPage(currentPage + 1);
        }
    }

    const goToPreviousPage = () => {
        if(canGoToPrevious()) {
            setCurrentPage(currentPage - 1);
        }
    }

    const getPageCountFromMetaData = () => {
        return freelancersMetaData?.last_page;
    }

    const canGoToNextPage = () => {
        return freelancersMetaData?.last_page > currentPage;
    };

    const canGoToPrevious = () => {
        return currentPage > 1;
    };

    return (
        <div>
            <div className={'mb-2 '}>
                <div className={'grid grid-cols-1 md:grid-cols-3 gap-4 items-end'}>
                    <div>
                        <TextInput
                            type={'text'}
                            name={'search'}
                            translationIndex={null}
                            placeholder={t('general.actions.search')}
                            onChange={(e) => setSearch(e.target.value)}
                        >
                        </TextInput>
                    </div>
                    <div>
                        <SelectInput
                            name={'statuten_filter'}
                            options={statutenOptions}
                            multiple={true}
                            control={control}
                            setValue={(fieldName, value) => {
                                setValue('statuten_filter', value);
                                setStatutenFilter(value);
                                setCurrentPage(1);
                            }}
                            currentValue={getValues('statuten_filter') ?? []}
                            translationIndex={'freelancers_module.filter_statuut'}
                        />
                    </div>
                    <div className={'mb-2 text-right'}>
                        {freelancersMetaData?.total && (
                            <p className={'text-sm text-gray-600'}>
                                {t('freelancers_module.total_count')}: <span className={'font-semibold'}>{freelancersMetaData.total}</span>
                            </p>
                        )}
                    </div>
                </div>
            </div>

            <BaseCard>
                {
                    !isLoading && (
                        <div>
                            <div className={'grid grid-cols-1 md:grid-cols-3 gap-4'}>
                                {
                                    freelancers.map((freelancer, index) => {
                                        return (
                                            <IconInputCard
                                                icon={faUser}
                                                isImage={true}
                                                onClick={() => {
                                                    navigate(`/admin/freelancers/${freelancer.id}`)
                                                }}
                                                otherImage={DocumentsAdd}
                                                showArrow={true}
                                                key={`freelancer_admin_${index}`}
                                            >
                                                <div className={'flex flex-row justify-between'}>
                                                    <div>
                                                        <p className={'text-xs text-gray-500'}>{freelancer.firstname} {freelancer.lastname}</p>
                                                        <p className={'text-xs'}>{freelancer.email}</p>
                                                        {(() => {
                                                            const main = freelancer.main_statuut ?? 'freelance';
                                                            const extras = freelancer.extra_statuten ?? [];
                                                            const all = [main, ...extras];
                                                            const abbr = {freelance: 'F', interim: 'I', student: 'S', flexi_job: 'X'};
                                                            const isNonFreelance = main !== 'freelance' || extras.length > 0;
                                                            return (
                                                                <span className={`text-xs mt-1 inline-block px-1.5 py-0.5 rounded ${isNonFreelance ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-700'}`}>
                                                                    {all.map(s => abbr[s] ?? s).join('/')}
                                                                </span>
                                                            );
                                                        })()}
                                                    </div>
                                                </div>
                                            </IconInputCard>
                                        )
                                    })
                                }
                            </div>

                            <div className="flex sm:flex-row flex-col w-full mt-8 items-end justify-end gap-2 text-xs">
                                <div className="flex gap-2">
                                    <button
                                        className={`${
                                            !canGoToPrevious()
                                                ? 'bg-gray-100'
                                                : 'hover:bg-gray-200 hover:cursor-pointer bg-gray-100'
                                        } rounded p-1`}
                                        onClick={() => setCurrentPage(1)}
                                        disabled={!canGoToPrevious()}
                                    >
                                        <span className="w-5 h-5">{'<<'}</span>
                                    </button>
                                    <button
                                        className={`${
                                            !canGoToPrevious()
                                                ? 'bg-gray-100'
                                                : 'hover:bg-gray-200 hover:curstor-pointer bg-gray-100'
                                        } rounded p-1`}
                                        onClick={() => {
                                            goToPreviousPage()
                                        }}
                                        disabled={!canGoToPrevious()}
                                    >
                                        <span className="w-5 h-5">{'<'}</span>
                                    </button>
                                    <span className="flex items-center gap-1">
                            {currentPage} / {getPageCountFromMetaData()}
                        </span>
                                    <button
                                        className={`${
                                            !canGoToNextPage()
                                                ? 'bg-gray-100'
                                                : 'hover:bg-gray-200 hover:cursor-pointer bg-gray-100'
                                        } rounded p-1`}
                                        onClick={() => {
                                            goToNextPage()
                                        }}
                                        disabled={!canGoToNextPage()}
                                    >
                                        <span className="w-5 h-5">{'>'}</span>
                                    </button>
                                    <button
                                        className={`${
                                            !canGoToNextPage()
                                                ? 'bg-gray-100'
                                                : 'hover:bg-gray-200 hover:cursor-pointer bg-gray-100'
                                        } rounded p-1`}
                                        onClick={() => setCurrentPage(getPageCountFromMetaData())}
                                        disabled={!canGoToNextPage()}
                                    >
                                        <span className="w-5 h-5">{'>>'}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                }

                {
                    isLoading && (
                        <div className="flex justify-center items-center col-span-3">
                            <div
                                className="animate-spin rounded-full mx-auto h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
                        </div>
                    )
                }

            </BaseCard>
        </div>
    )
}